module.exports = __webpack_public_path__ + "img/closedNum.a109fc4d.png";